// src/pages/xray/XrayLobby/TabRouting.js
import React from 'react';

const TabRouting = ({
  selectedTabsRouting,
  setSelectedTabsRouting,
  routingTable,
  cidrRanges,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['Routing Table', 'CIDR Ranges'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedTabsRouting === `tabsRouting${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedTabsRouting === `tabsRouting${index + 1}`}
              onChange={() => setSelectedTabsRouting(`tabsRouting${index + 1}`)}
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedTabsRouting === 'tabsRouting1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">IP Routing Table</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {routingTable || 'No IP Routing Table status available'}
            </pre>
          </div>
        )}

        {selectedTabsRouting === 'tabsRouting2' && (
          <div>
            <h1 className="font-bold text-2xl p-2">CIDR /30 /29 /24 RANGES</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {cidrRanges || 'No CIDR RANGES status available'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabRouting;
